import { render, staticRenderFns } from "./sysConfigs.vue?vue&type=template&id=ddf2a4ec&"
import script from "./sysConfigs.vue?vue&type=script&lang=js&"
export * from "./sysConfigs.vue?vue&type=script&lang=js&"
import style0 from "./sysConfigs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sysConfigs.vue"
export default component.exports